import SEPlayApi from '../SEPlayApi';

export function getOrderImageReference(orderId: number) {
    return SEPlayApi.getImageReference(orderId);
}
